import React from "react";
import { PlayersListItem } from "../../../types/players";
import FlightRow from "./FlightRow";

type FlightProps = {
  flight: Array<Partial<PlayersListItem & { playerId: number; toPar: string }>>;
  flightNumber: number;
  holeNumber: number;
};

const Flight: React.FC<FlightProps> = ({
  flight,
  flightNumber,
  holeNumber,
}) => {
  return (
    <div className="pt-10">
      <div className="pb-9">
        <h3 className="text-xs font-bold text-darkgrey uppercase">Players</h3>
      </div>
      <table className="w-full">
        <tbody>
          {flight.map((f, i) => {
            return (
              <FlightRow
                key={f.playerId}
                index={i}
                currentHole={holeNumber}
                player={f}
              />
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default Flight;
